import React from "react"
import {
  Paper,
  styled,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Box,
  Avatar,
  IconButton
} from "@mui/material"
import { useTheme } from "@mui/system"
import EditIcon from "@mui/icons-material/Edit"
import GroupsIcon from "@mui/icons-material/Groups"
import AppPagination from "components/StyledComponents/AppPagination"
import TableNoRecords from "components/TableNoRecords"
import { groupColumns } from "helpers/constant"

const CustomTable = styled(Table)(({ theme }) => ({
  backgroundColor: theme.palette.background.main,
  borderCollapse: "collapse !important",
  "& .MuiTableCell-root": {
    padding: "12px 24px 12px 0px",
    backgroundColor: theme.palette.background.main,
    borderBottom: "none",
    boxSizing: "border-box",
    "&:last-child": { paddingRight: 0 }
  },
  "& .MuiTableRow-root": {
    borderBottom: `2px solid #272a2c`,
    "&:last-child": { borderBottom: "none" }
  },
  "& .MuiTableCell-head": {
    verticalAlign: "bottom",
    position: "sticky",
    borderBottom: `2px solid #272a2c`,
    "&:last-child": { paddingRight: 0 }
  }
}))

const GroupListTable = ({ rows = [], isLoading, onEdit, currentPage, setPage }) => {
  const theme = useTheme()
  const itemsPerPage = 12
  const totalPages = Math.ceil(rows?.length / itemsPerPage)

  const paginatedRows = rows?.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage)

  return (
    <>
      <Paper sx={{ width: "100%", overflow: "hidden" }}>
        <TableContainer sx={{ maxHeight: 700 }}>
          <CustomTable stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                {groupColumns?.map((column) => (
                  <TableCell
                    key={column.id}
                    align={column.align}
                    style={{ minWidth: column.minWidth }}>
                    <Typography variant="body2Regular" style={{ opacity: 0.6 }}>
                      {column.label}
                    </Typography>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {paginatedRows.length ? (
                paginatedRows.map((row) => (
                  <TableRow key={row.id}>
                    <TableCell>
                      <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                        {row.icon_url ? (
                          <Avatar
                            src={row.icon_url}
                            sx={{ width: 32, height: 32 }}
                            variant="rounded"
                          />
                        ) : (
                          <Avatar
                            sx={{
                              width: 32,
                              height: 32,
                              bgcolor: `${theme.palette.aqua.main}20`
                            }}
                            variant="rounded">
                            <GroupsIcon fontSize="small" sx={{ color: theme.palette.aqua.main }} />
                          </Avatar>
                        )}
                        <Typography variant="body2Regular">{row.name}</Typography>
                      </Box>
                    </TableCell>
                    <TableCell>
                      <Typography variant="body2Regular">{row.email}</Typography>
                    </TableCell>
                    <TableCell>
                      <Typography
                        variant="body2Regular"
                        sx={{ fontFamily: "monospace", fontSize: "12px" }}>
                        {row.domain_name}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography variant="body2Regular">{row.restaurant_count ?? 0}</Typography>
                    </TableCell>
                    <TableCell align="center" onClick={(e) => e.stopPropagation()}>
                      <IconButton
                        size="small"
                        onClick={() => onEdit(row)}
                        sx={{ color: theme.palette.aqua.main }}>
                        <EditIcon fontSize="small" />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableNoRecords
                  colSpan={groupColumns?.length}
                  label={isLoading ? "Loading groups..." : "No Restaurant Groups Found"}
                />
              )}
            </TableBody>
          </CustomTable>
        </TableContainer>
      </Paper>
      {rows?.length > 0 && (
        <AppPagination onPageChange={setPage} totalPages={totalPages} currentPage={currentPage} />
      )}
    </>
  )
}

export default GroupListTable
